export const WAEC_FURTHER_MATHS = [];
